<template>
    <div class="modal-header tw-relative tw-flex tw-items-center tw-font-bold tw-mr-3 tw-px-2 tw-text-gray-400 hover:tw-opacity-75 hover:tw-cursor-pointer" :class="{'tw-text-blue-700': isActive}" @click="switchTab">
        <slot></slot>
        <div v-if="isActive" class="header-active tw-absolute tw-bottom-0 tw-left-0 tw-bg-blue-700 tw-w-full"></div>
    </div>
</template>

<script>
    export default {
        name: 'ModalHeader',

        props: {
            activeTab: {
                required: true,
                default: false,
            },
            name: {
                required: true,
            },
        },

        computed: {
            isActive() {
                return this.activeTab === this.name;
            },
        },

        methods: {
            switchTab() {
                if (this.activeTab !== this.name) {
                    this.$emit('switchTab', this.name);
                }
            },
        },
    };
</script>
